import classNames from "classnames/dedupe";
import NextLink, { LinkProps as NextLinkProps } from "next/link";
import { ReactNode } from "react";

type LinkProps = NextLinkProps & {
  className?: string;
  children: ReactNode;
  variant?: "primary" | "secondary" | "danger";
};

export function Link({ href, className, variant = "primary", children }: LinkProps) {
  return (
    <NextLink
      href={href}
      className={classNames(
        "inline-flex items-center",
        {
          "text-purple-600 dark:text-purple-500": variant === "primary",
          "text-muted-foreground": variant === "secondary",
          "text-red-600 dark:text-red-500": variant === "danger",
        },
        className,
      )}
    >
      {children}
    </NextLink>
  );
}

export function NavLink({ href, className, children, ...rest }: LinkProps) {
  return (
    <NextLink href={href} className={classNames("font-medium leading-5", className)} {...rest}>
      {children}
    </NextLink>
  );
}

export default Link;
